import React from "react";
import logo from "../logo.png";

export default function Header() {
	return (
		<div className="sticky top-0 left-0 z-50 shadow-lg">
			<div className="flex items-center justify-between bg-gradient-to-r from-[#667EEA] via-[#ED64A6] to-[#667EEA] p-2">
				<div className="flex justify-left">
					<a
						href="/"
						className="text-xl mx-2"
					>
						<img
							src={logo}
							className="w-36 pt-1"
							alt="logo"
						/>
					</a>
				</div>
				{/* <div className="justify-center text-gray-100 flex">
					<p className="mx-6 text-sm text-center">
						Just drop a message at{" "}
						<a
							href="tel:+91-9716609422"
							className="border-b font-bold whitespace-nowrap"
						>
							(+91)-9716609422
						</a>{" "}
						to request a callback.
					</p>
				</div> */}
			</div>
		</div>
	);
}
